import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage, useIntl} from 'react-intl';

import {IStore} from 'redux/interface';
import {getTranslations} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {Pages, TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import {ReactComponent as XpeditionIcon} from 'assets/image/menu-auth/xpedition.svg';
import {getLocalizedTitle} from 'components/header/utils';

import './styles.scss';
import {dialogueClearedAction} from '../../redux/dialogue/actions';
import {BotMode} from '@wholesalechange/chatcomponent';

export const Xpedition: React.FunctionComponent = () => {
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const {
    locale
  } = useSelector((state: IStore) => state.translation);

  const dispatch = useDispatch();
  const intl = useIntl();

  useEffect(() => {
    dispatch(closeArticle());
    dispatch(dialogueClearedAction());
  }, []);

  const translationKey = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Xpedition.toLowerCase());

    return page?.translationKey || TranslationKeys.Chat;
  }, [settings]);

  const title = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Xpedition.toLowerCase());

    return page?.title || Pages.Xpedition;
  }, [settings]);

  const localizedTitle = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Xpedition.toLowerCase());

    return getLocalizedTitle(page?.title, page?.titles, locale);
  }, [settings, locale]);

  useGetTranslations({translationKey});

  return <div className="xpedition">
    {
      !loading.includes(getTranslations) && <>
        <h1 className="xpedition__title">
          {/* <XpeditionIcon className="xpedition__icon"/>*/}
          {localizedTitle || (
            <FormattedMessage
              id={`gritx.common.navigation.${title}`}
              defaultMessage={title}
            />
          )}
        </h1>
        <BotChat chatType={BotType.XpeditionList} chatMode={BotMode.NoHistory}
          title={intl.formatMessage({
            id: 'gritx.xpedition.title',
            defaultMessage: 'Xpedition'
          })}
          tabsEnabled={settings?.chatSettings?.tabsEnabled || false}/>
      </>
    }
  </div>;
};
